import { createSelector } from 'reselect'

const cancellationSelector = (state) => state.cancellation

export const isSubmittingSelector = createSelector(
  cancellationSelector,
  (cancellation) => cancellation.submitting
)
